<i18n>
{
  "en": {
    "title": "Frequently asked questions",
    "faqs": [
      {
        "question": "I can’t download my VCard file. what’s wrong?",
        "answer": "You can follow here our step by step tutorial to download your data."
      },
      {
        "question": "My contacts are ultra confidential, do you keep track of them?",
        "answer": "No, VCardConverter has no access to your csv or VCard data: everything is stored on your web browser. None of your contacts are sent to our servers, we only process your payments and credentials to keep you signed-in. You are the only owner of your contacts."
      },
      {
        "question": "Does VCardConverter work with google csv contacts?",
        "answer": "Yes, VCardConverter allows to convert Gmail csv files to VCard (.vcf) file. Simply choose the setting 'Google CSV' in the dropdown list"
      },
      {
        "question": "Does VCardConverter work with other type of csv",
        "answer": "Yes, VCardConverter allows to convert custom csv files to VCard (.vcf) file. Simply choose the setting 'Custom CSV' in the dropdown list. "
      },
      {
        "question": "Does VCardConverter work with Outlook csv contacts?",
        "answer": "Yes, VCardConverter allows to convert Outlook csv files to VCard (.vcf) file. Simply choose the setting 'Outlook CSV' in the dropdown list."
      },
      {
        "question": "How many contacts can I convert?",
        "answer": "If you use the FREE plan you can convert up to 10 contacts to VCard. If you need more, you can select the 30 days plan which allows to convert for 30 days on any type of device as much contacts as your csv file counts. Alternatively you can opt for the Lifetime plan to enjoy unlimited conversion forever"
      },
      {
        "question": "How many files can I convert?",
        "answer": "It is simple, you can convert as many files as you want."
      },
      {
        "question": "Can I convert VCard file (.vcf extension) to csv?",
        "answer": "Yes, it is possible to reverse VCardConverter to convert VCard file to csv file. Simply toggle it to “VCard to csv” and click on Convert me."
      },
      {
        "question": "How can I use my VCard converted file?",
        "answer": "If you want to import your contacts to your mac : simply open the contact app, then click on Folder/import and select your VCardConverter file :) If you want to import your contacts to your iPhone : On your desktop browser or on your iPad go to iCloud.com, select contact, then click on the tiny wheel on the down left corner, select “import VCard” and choose your VCard converted file to upload it on iCloud and use it on each single iDevice synced with your apple ID"
      },
      {
        "question": "Can I download my VCard on any type of device?",
        "answer": "Yes VCardConverter is compatible with all types of browsers and operating systems, computer and mobile."
      },
      {
        "question": "I would like to be refunded. How to do?",
        "answer": "Unless otherwise stated, any converted generated file by VCardConverter is a digital service and thus can not be refunded. In case of doubt please do not use VCardConverter."
      }
    ]
  }
}
</i18n>

<script>
export default {
  data() {
    return { faqs: this.getFaqs() };
  },

  watch: {
    '$i18n.locale': {
      handler() {
        this.faqs = this.getFaqs();
      },
    },
  },

  methods: {
    getFaqs() {
      // bug in i18n, array is returned as OBJ in i18n block
      return Object.values(this.$t('faqs'))
        .map((faq) => {
          const one = { ...faq };

          if (typeof one.isOpen === 'undefined') {
            one.isOpen = false;
          }

          return one;
        });
    },
    toggleFaq(faq) {
      faq.isOpen = !faq.isOpen;

      if (faq.isOpen) {
        this.$trackCategory('FAQ', 'click', faq.question);
      }
    },
  },
};
</script>

<template>
  <div class="theFaq">
    <h2 class="theFaq_title" v-t="'title'" />
    <dl>
      <template v-for="faq in faqs">
        <dt
          :key="`dt-${faq.question}`"
          class="theFaq_q"
          :class="{'is-open': faq.isOpen}"
          @click="toggleFaq(faq)"
        >
          {{ faq.question }}
        </dt>
        <dd :key="`dd-${faq.question}`" v-show="faq.isOpen" class="theFaq_a">
          {{ faq.answer }}
        </dd>
      </template>
    </dl>
  </div>
</template>

<style lang="scss" scoped>
.theFaq {
  padding: 40px 0;
  text-align: left;

  &_title {
    margin-bottom: 40px;
    font-size: 24px;
    font-weight: 700;
    text-align: center;
    color: map.get($colors,'black');
  }

  &_q {
    padding: 20px;
    font-size: 16px;
    font-weight: 700;
    color: map.get($colors,'grey');
    border: 1px solid rgba(map.get($colors,'grey'), 0.4);
    background: map.get($colors,'light');
    cursor: pointer;

    &.is-open {
      border-bottom: 0;
    }

    &:before {
      content: ' + ';
      font-weight: 700;
    }

    &.is-open:before {
      content: ' - ';
    }

    &:not(:first-child) {
      margin-top: 10px;
    }
  }

  &_a {
    padding: 0 10px 20px;
    font-size: 16px;
    text-align: left;
    border: 1px solid rgba(map.get($colors,'grey'), 0.4);
    border-top: 0;
    background: map.get($colors,'light');
  }
}
</style>
